import React from 'react';
import { LinkExternalIcon } from '@primer/octicons-react';
import { hyperExecuteHref } from '../../links';
import styles from './header.module.css';

/** Compact "HyperExecute ↗" link for the detail breadcrumb bar — the job
 * page for external_id.hyper_job_id; renders nothing without one. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function HyperExecuteLink(_ref) {
  var jobId = _ref.jobId;
  var href = hyperExecuteHref(jobId);
  if (!href) return null;
  return /*#__PURE__*/_jsxs("a", {
    className: styles.hyperExecuteCta,
    href: href,
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "View on HyperExecute (opens in a new tab)",
    "data-testid": "evidence-hyperexecute-link",
    children: [/*#__PURE__*/_jsx("span", {
      children: "View on HyperExecute"
    }), /*#__PURE__*/_jsx(LinkExternalIcon, {
      size: 14,
      "aria-hidden": "true"
    })]
  });
}